<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeItem from "./LinhaDeItem/LinhaDeItem.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraItem",
]);

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) =>{
    
    emits('update:alteraItem',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeItem v-for="item in props?.dado?.itens"
            :key="item.id"
            :dado="props?.dado"
            :item="item"
            @update:alteraItem="alteraItem"
        ></LinhaDeItem>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>